import React, {useEffect, useState} from "react";

import {formatCurrency} from "./utility";

/**
 * this component is the header, simply receives props and renders html accordingly
 * no big deal :)
 */
const PackHeader = (props) => {
  const [loadingUrl, setloadingUrl] = useState(false);
  console.log(props);

  const {
    label,
    billingCycle,
    resume,
    showTitle,
    title,
    price,
    oldPrice,
    url,
    urlCustom,
    urlText,
    UrlTriggerEventCaution,
    event,
    promotion,
    discount,
    discountText,
  } = props;

  useEffect(() => {
    if (resume) window.BrandLib.refresh();
  }, []);

  /*
   *	Check if URL is valid
   *	case valid go to url
   *	else open byside triggerEvent
   */
  const CheckUrl = (url, urlTriggerEventCaution) => {
    if (!url) {
      return bysideWebcare_triggerevent(urlTriggerEventCaution);
    }
    //adiciona o loading ao botão
    setloadingUrl((currentState) => !currentState);

    // request.open('GET', 'https://app-9015f501-af0b-463a-b954-ab7059b01626.apps.qa.meo.pt/api/FixedOffer/CreateOrderConfigurator?catalogId=170&amp;data=8417&amp;voice=8413', false);
    var RequestChecker = new XMLHttpRequest();

    // Opens the file and specifies the method (get)
    // Asynchronous is true
    RequestChecker.open("get", url, true);

    //check each time the ready state changes
    //to see if the object is ready
    RequestChecker.onreadystatechange = checkReadyState;

    function checkReadyState() {
      if (RequestChecker.readyState === 4) {
        //check to see whether request for the file failed or succeeded
        if (RequestChecker.status == 200 || RequestChecker.status == 0) {
          window.location.href = url;
        } else {
          setloadingUrl((currentState) => !currentState);

          if (
            typeof bysideWebcare_triggerevent === "function" &&
            urlTriggerEventCaution
          ) {
            bysideWebcare_triggerevent(urlTriggerEventCaution);
          } else {
            console.log("url || urlTriggerEventCaution not exists");
          }
          return;
        }
      }
    }
    RequestChecker.send(null);
  };

  return (
    <div
      className={"pack-header" + (resume ? " collapse-header switcherOff" : "")}
    >
      {label && label.text ? (
        <ul className="labels">
          <li>
            <span className={label.type}>{label.text}</span>
          </li>
        </ul>
      ) : null}
      <div className="title-container">
        <div className="title-wrapper">
          {showTitle ? (
            <div className="pack-title">
              <h4>{title}</h4>
            </div>
          ) : null}
          <div className="pack-price">
            <h2 className="price-actual">
              {formatCurrency(price)}
              {/*check if billingCycle is WEEKLY else set default value*/}
              {/*in future if you need set a different text is possible */}
              <span>/{billingCycle === "WEEKLY" ? "semana" : "mês"}</span>
            </h2>
            {oldPrice ? (
              <p className="price-old">{formatCurrency(oldPrice)}</p>
            ) : null}
          </div>
        </div>

        {!url || url.startsWith("http") ? (
          <div className="btn-wrapper">
            <a
              className={
                //todo//
                "btn-secondary btn-color-3 btn-tiny" +
                (loadingUrl
                  ? " btn-inactive btn-loading iconLoading-white"
                  : "")
              }
              href="javascript:void(0)"
              onClick={() => CheckUrl(urlCustom || url, UrlTriggerEventCaution)}
              {...(event !== undefined ? event : "")}
            >
              {urlText ? urlText : "Aderir"}
            </a>
          </div>
        ) : (
          /*
           * this bit below here is in plain HTML because of React's warning on javascript URI getting passed to link's href prop
           * like this the warning is silenced and future react builds will not throw an error.
           */

          <div
            className="btn-wrapper"
            dangerouslySetInnerHTML={{
              __html: `
				<a href="${url}" ${Object.keys(event)
                .map((k) => `${k}="${event[k]}"`)
                .join(" ")} class="btn-secondary btn-color-3 btn-tiny">${
                urlText ? urlText : "Aderir "
              }</a>
			`,
            }}
          ></div>
        )}
      </div>
      <div className="price-desc">
        {promotion ? (
          <React.Fragment>
            {promotion.text ? (
              <p
                className="txt-dest"
                dangerouslySetInnerHTML={{__html: promotion.text}}
              />
            ) : null}
            {discount ? (
              discountText ? (
                <p
                  className="txt-dest"
                  dangerouslySetInnerHTML={{
                    __html: `
                  ${discountText
                    .replace(
                      new RegExp("{{discount}}", "g"),
                      `${formatCurrency(discount)}`
                    )
                    .replace(
                      new RegExp("{{months}}", "g"),
                      `${promotion.months}`
                    )} `,
                  }}
                />
              ) : (
                <p className="txt-dest">
                  Inclui <b>{formatCurrency(discount)}</b> de desconto durante{" "}
                  {promotion.months} {promotion.months == 1 ? "mês" : "meses"}
                </p>
              )
            ) : null}
            {promotion.priceAfter && promotion.months ? (
              <p>
                {formatCurrency(promotion.priceAfter)} após {promotion.months}º
                mês
              </p>
            ) : null}
          </React.Fragment>
        ) : null}
      </div>
    </div>
  );
};

export default PackHeader;
